import { isStaffCustomerScopedUser } from "../../../utils/staffCustomerAccess";

import { formatIncomingDate, formatIncomingCreatedAt, parseIncomingCreatedAt } from "./incomingPatientDates";

const text = (value) => String(value == null ? "" : value).trim();

export const sortIncomingRecords = (records) => [...records].sort((left, right) => {
  const scheduledOrder = Number(Boolean(text(left.sleepStudyDate))) - Number(Boolean(text(right.sleepStudyDate)));
  if (scheduledOrder) return scheduledOrder;
  const leftDate = parseIncomingCreatedAt(left.createdAt);
  const rightDate = parseIncomingCreatedAt(right.createdAt);
  // Keep legacy rows visible without treating a missing timestamp as an old date.
  if (!leftDate) return rightDate ? 1 : 0;
  if (!rightDate) return -1;
  return rightDate.getTime() - leftDate.getTime();
});

export const getIncomingCustomerOptions = (nodes, customerLists, records, node = "") => {
  const options = new Set();
  nodes.forEach((item, index) => {
    if (!node || item.nodename === node) {
      (customerLists[index] || []).forEach((customer) => { if (text(customer)) options.add(text(customer)); });
    }
  });
  // Preserve historical customers that still occur in accessible incoming rows.
  records.forEach((record) => {
    if ((!node || record.nodeRef === node) && text(record.refCustomer)) options.add(text(record.refCustomer));
  });
  return Array.from(options).sort((a, b) => a.localeCompare(b));
};

export const getIncomingAssignedDefaults = (currentUser, nodes, customerLists, selectedNode) => {
  if (!isStaffCustomerScopedUser(currentUser)) return { node: "", customer: "" };
  const node = selectedNode === undefined ? ((nodes[0] || {}).nodename || "") : selectedNode;
  if (!node || !nodes.some((item) => item.nodename === node)) return { node: "", customer: "" };
  const customers = getIncomingCustomerOptions(nodes, customerLists, [], node);
  return { node, customer: customers[0] || "" };
};

export const filterIncomingRecords = (records, { node = "", customer = "", status = "", field = "firstname", search = "", noSleepStudyDate = false } = {}) => {
  const needle = text(search).toLocaleLowerCase();
  return records.filter((record) => {
    if (node && record.nodeRef !== node) return false;
    if (customer && text(record.refCustomer) !== customer) return false;
    if (status && record.status !== status) return false;
    if (noSleepStudyDate && text(record.sleepStudyDate)) return false;
    if (!needle) return true;
    const value = field === "hn" ? text(record.hn)
      : [record.firstnameTh, record.lastnameTh, record.firstnameEn, record.lastnameEn].map(text).join(" ");
    return value.toLocaleLowerCase().includes(needle);
  });
};

export const buildIncomingExportRows = (records) => records.map((record) => ({
  Status: text(record.status),
  "Sleep Study Date": formatIncomingDate(record.sleepStudyDate),
  "Created At": formatIncomingCreatedAt(record.createdAt),
  Node: text(record.nodeRef),
  Customer: text(record.refCustomer),
  "Company HN": text(record.hn),
  "Hospital HN": text(record.refHn),
  "Patient Name": [record.firstnameTh, record.lastnameTh].map(text).filter(Boolean).join(" ") ||
    [record.firstnameEn, record.lastnameEn].map(text).filter(Boolean).join(" "),
  Gender: text(record.gender),
  "Date of Birth": formatIncomingDate(record.dateOfBirth),
  Phone: text(record.mobile),
  "Health Insurance": text(record.healthInsurance),
  Note: text(record.note),
}));
